import React from 'react';
import Comments, { type IssueViewCommentProps } from './comments-view.tsx';

const IssueViewComments = ({ rootRelayFragment }: IssueViewCommentProps) => (
	<Comments rootRelayFragment={rootRelayFragment} />
);

export default IssueViewComments;
